import { FC } from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { Input, message, Popover } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { copy } from '@/shared/utils/misc';

type InputCopyProps = {
  value: string;
  copiedText?: string;
  readonly?: boolean;
};

export const InputCopy: FC<InputCopyProps> = ({ value, copiedText, readonly }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const clickCopy = async () => {
    try {
      await copy(value);
      if (copiedText) {
        messageApi.open({ type: 'success', content: copiedText });
      }
    } catch (e) {
      //
    }
  };

  return (
    <>
      {contextHolder}
      <StyledInput
        data-testId="generated"
        value={value}
        readOnly={readonly}
        suffix={
          <Popover content={<span>Copied</span>} trigger="click">
            <CopyOutlined onClick={clickCopy} />
          </Popover>
        }
      />
    </>
  );
};

const StyledInput = styled(Input)`
  &&& {
    input {
      color: ${COLORS.colorLink};
    }
  }
`;
